/* eslint-disable react/no-array-index-key */
import { Box, Popover, PopoverBody, PopoverContent, PopoverTrigger } from '@chakra-ui/react';

import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const BUTTON_VARIANT = { filled: 'filled', outlined: 'outlined', tertiary: 'tertiary' };

export const REVIEW_CYCLE_EVENTS = {
  NOMINATOR: { name: 'Nomination' },
  SELF: { name: 'Self review' },
  PEER: { name: 'Peer review' },
  UPWARD: { name: 'Upward review' },
  MANAGER: { name: 'Manager review' },
  DLM: {
    name: 'Dotted-line manager review',
  },
  RATING_CALIBRATE: { name: 'Calibration' },
};

const CornerIcon = () => (
  <Box
    w="10px"
    h="10px"
    bg="icon.g3"
    borderRadius="2px"
    transform="rotate(45deg)"
    mt="1px"
    className="timeline-icon timeline-diamond-icon"
  />
);

const MiddleIcon = () => (
  <Box className="timeline-icon timeline-circular-icon" w="12px" h="12px" borderRadius="50%" bg="icon.g3" />
);

const Node = ({ isFirstOrLast = false }) => {
  let IconComp = null;
  if (isFirstOrLast) {
    IconComp = CornerIcon;
  } else {
    IconComp = MiddleIcon;
  }

  return (
    <Box w="16px" h="16px" display="flex" zIndex={0}>
      <IconComp />
    </Box>
  );
};

const ConnectingLine = () => <Box flexGrow={1} h="2px" bg="border.CFD7DF" ml="-12px" mr="-9px" mt="5px" />;

const InfoTooltip = ({ children }) => (
  <Popover trigger="hover" placement="top-start">
    <PopoverTrigger>{children}</PopoverTrigger>
    <PopoverContent bg="transparent" border="none" boxShadow="none">
      <PopoverBody maxW="maxContent">
        <PaperWithShadow p={2} width="220px">
          hello
        </PaperWithShadow>
      </PopoverBody>
    </PopoverContent>
  </Popover>
);

export const ReviewCreationTimeline = ({ timelineData = [] }) => (
  <Box>
    <Box display="flex" p="16px" width="100%" overflowX="auto">
      {timelineData.map((nodeData, index) => (
        <Box display="flex" flexDir="column" flexGrow={1} key={index} minW="120px" id="xyz">
          <Box>
            <Box display="flex" key={nodeData.reviewStage}>
              <Node isFirstOrLast={index === 0 || index === timelineData.length - 1} />
              {index < timelineData.length - 1 && <ConnectingLine />}
            </Box>

            {/* <InfoTooltip key={index} title={REVIEW_CYCLE_EVENTS[nodeData.reviewStage]?.name}> */}
            <Box>
              <TextBodyMedium bold mt={2}>
                {REVIEW_CYCLE_EVENTS[nodeData.reviewStage]?.name}
              </TextBodyMedium>
              <Box>{nodeData.detailsComp}</Box>
            </Box>
            {/* </InfoTooltip> */}
          </Box>
        </Box>
      ))}
    </Box>
  </Box>
);
